import { withProps } from 'recompose';
import { ru } from 'date-fns/locale';

export default withProps({
  dateFormat: 'DD.MM.YYYY',
  dateOptions: {
    locale: ru
  }
});
